import { AppointmentInventory } from './appointment-inventory.model';
import { Attachment } from './attachment.model';
import { Charge } from './charge.model';
import { CustomerService } from './customer-service.model';
import { DataTabSection } from './data-tab-section.model';
import { WorkforceFormEntry } from './workforce-form.model';
import { Linecard } from './linecard.model';

export class Appointment {
	id = 1;
	ticketId = 1;
	ticketTypeId = 1;
	ticketTypeShortCode = '';
	ticketTypeDesc = '';
	ticketState = 1;
	ticketCodeId = 1;
	ticketCodeDesc = '';
	ticketStatusId = 1;
	ticketStatusDesc = '';
	ticketStatusIsEndStatus = false;
	techId = 1;
	ticketPriority = 1;
	ticketPriorityDesc = '';
	displayValue = '';
	apptBlock = 'A';
	apptBlockDesc = 'AM';
	driveStartTime = '';
	apptStart = '';
	apptEnd = '';
	fullAddress = '';
	ticketStructureLink = 1;
	dataTab = '' as string | DataTabSection[];
	attachments = [] as Attachment[];
	additionalCharges = [] as Charge[];
	services = [] as CustomerService[];
	inventory = [] as AppointmentInventory[];
	linecards = [] as Linecard[];
	forms = [] as WorkforceFormEntry[];

	constructor(init?: Partial<Appointment>) {
		Object.assign(this, init);
	}
}
